export default __webpack_public_path__ + "static/media/MED-logo-rgb.2178e097.png";